import styled from 'styled-components';
import { TicketCounter } from './ticketCounter';
import { themeColor } from '../../../../../theme/getters';

export const Container = styled.div``;

export const TicketCounterLine = styled(TicketCounter)`
  &:not(:last-of-type) {
    border-bottom: 1px solid ${themeColor('border')};
  }
`;
